/* eslint-disable */
/**
 * Common JS that should be imported on every page.
 */

import '@zr/common/js/jquery_global';
import './page_data';

import '@static/js/jquery.cookie';

// import './google_analytics';
import './logging';
import './automation_ready';
import './doc_loading';
import {initZdsTextInput} from "@seo/js/partials/zds/_text-input";
import { initTracking } from './tracking';
import { checkFeature } from '../utils/features';
import initGoogleLogin from './google_login';

// Support lazy loaded CSS. https://github.com/filamentgroup/loadCSS/blob/master/README.md
// TODO: Don't do this anymore. Just use await import.
$(document).ready(() => {
  const isGoSerp = zr.page.model.isSerp;
  // TODO disable the time_on_page tracking for Go SERPs until the lag caused by the tracking
  // can be fixed
  if (!isGoSerp) {
    initTracking();
  }

  // incase we are on the job page showing the email apply modal render the google login
  // later when the modal is displayed via lazy loading in rich-job-zds.js
  if ($('.email_apply_modal').length === 0) {
    initGoogleLogin();
  }

  // Hotjar Heatmap
  if (checkFeature('hotjar')) {
    import('./hotjar').then(({ default: initHotjar }) => initHotjar(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv='));
  }

  initZdsTextInput();

  $('[data-css-lazy-load]').on('load', (e) => { e.target.media = 'all'; });

  $('[data-css-lazy-load]').each((i, style) => {
    try {
      if (style.sheet.cssRules) {
        style.media = 'all'; // eslint-disable-line no-param-reassign
      }
    } catch {
      // Stylesheet hasn't been loaded.
    }
  });
});
